"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCurrencies;
var _request = _interopRequireDefault(require("@godaddy/request"));
const plCurrencyBlocklist = [];

/**
 * Callback type for getCurrencies
 *
 * @callback getCurrenciesCallback
 * @param {Object} err Error object
 * @param {Array} currencies An array of currencies
 */
/**
 * Gets a list of currencies asynchronously
 *
 * @param {String} guiUrl URL to the Presentation Central GUI endpoint
 * @param {String} [marketId='en-US'] The currently selected market
 * @param {Number} [privateLabelId=1] Private Label ID
 * @param {getCurrenciesCallback} done Callback to run after currencies are retrieved
 *
 * @readonly
 * @memberOf Markets
 * @api public
 */
function getCurrencies(guiUrl, marketId, privateLabelId, done) {
  if (typeof marketId === 'function') {
    done = marketId;
    privateLabelId = 1;
    marketId = 'en-US';
  } else if (typeof privateLabelId === 'function') {
    done = privateLabelId;
    privateLabelId = 1;
  }
  const url = `${encodeURI(guiUrl)}pcjson/currency/display?marketId=${encodeURIComponent(marketId)}&pl_id=${privateLabelId}`;
  _request.default.get(url, {
    jsonp: true
  }, (error, currencies) => {
    if (error) {
      return done(error);
    }
    if (privateLabelId === 1) {
      return done(null, currencies);
    }
    done(null, currencies.filter(currency => plCurrencyBlocklist.indexOf(currency.currencytype) === -1));
  });
}